var FormUtils = function () {

  this.disableButtonOnSubmit = function(formId) {
    var obj = this;
    jQuery(formId).submit(function () {
      // If the form is a dialog, don't disable the submit button
      // In that case we are simply closing the dialog, but saving
      // state. We don't want the button disabled if the dialog is
      // opened again,
      if (jQuery(this).attr('method') == 'dialog') {
        return;
      }

      if(obj._requiredFieldsNotEmpty(formId)) {
        jQuery(this).find("*[type='submit']").prop('disabled',true);
      }
    });
  };

  this.enableSubmitButton = function(formId) {
    jQuery(formId).find("*[type='submit']").prop('disabled',false);
  };

  this._requiredFieldsNotEmpty = function(formId) {
    var result = true;
    jQuery(formId).find('input').each(function(){
      if(jQuery(this).prop('required') && !jQuery(this).val()){
        result = false;
      }
    });
    return result;
  }

};

// Make FormUtils globally available for inline scripts in ERB templates
window.FormUtils = FormUtils;
